import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthInfiniteQuery } from '#lib/hooks/use-query.js';

async function fetchItineraries(options, authHeaders) {
    const { pageParam, selectedTags = [], userId, query } = options;
    const response = await fetchAndParse(
        `${API_URL}/s/itineraries/search?userId=${userId}&query=${query}&lastCreated=${pageParam.created ?? ''}&lastId=${pageParam.id ?? ''}&tags=${selectedTags.join(
            ','
        )}`,
        {
            method: 'GET',
            headers: { ...jsonHeaders, ...authHeaders }
        }
    );

    return response.body;
}

// Dopo l'update di un itinerario
export function useSearch(options) {
    const { userId, query, selectedTags } = options;
    const { data, error, status, fetchNextPage, hasNextPage, isFetching } = useAuthInfiniteQuery({
        queryKey: ['itineraries', selectedTags, userId, query],
        queryFn: ({ pageParam = {} }, authHeaders) => fetchItineraries({ ...options, pageParam }, authHeaders),
        getNextPageParam: (res) => {
            return res.lastItemData;
        },
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        staleTime: 0,
        cacheTime: 0
    });

    const results = data?.pages?.flatMap((page) => page?.results);
    const tags = [...new Set(data?.pages?.flatMap((page) => page?.linkedTags))];

    return {
        data,
        itineraries: results ?? [],
        availableTags: tags ?? [],
        fetchNextPage,
        hasNextPage,
        isRefetching: isFetching,
        isLoading: status === 'loading',
        isSuccess: status === 'success',
        isError: status === 'error',
        error,
    };
}
